import React from 'react';
import { default as bemCssModules } from 'bem-css-modules';
import { getImageVariants, } from '@ori/image-sizes-helper';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import { useStore } from '../../store/AppStore';
import { default as ActiveShadeStyles } from './ActiveShade.module.css';
import { QuickBuy } from '../QuickBuy/QuickBuy';
const style = bemCssModules(ActiveShadeStyles);
const generateSrcset = (image) => image.map((variant) => `${variant.url} ${variant.width}w`).join(',');
export const ActiveShade = () => {
    const { name, brand, activeShade, shades } = useStore();
    if (!activeShade) {
        return null;
    }
    const imageVariantsConfig = {
        url: activeShade.imageUrl,
        backgroundColor: '#f5f5f5',
        params: [
            {
                width: 695,
                height: 695,
                quality: 60,
            },
            {
                width: 360,
                height: 360,
                quality: 90,
            },
        ],
    };
    const images = getImageVariants(imageVariantsConfig);
    return (React.createElement("div", { className: style() },
        React.createElement("div", { className: style('image-wrapper') },
            React.createElement("img", { className: [style('image'), 'lazyload'].join(' '), srcSet: generateSrcset(images), sizes: `(max-width: 767px) 696px, 360px`, src: images[images.length - 1].url, alt: activeShade.name }),
            React.createElement("div", { className: style('info') },
                React.createElement("div", { className: style('brand') }, brand),
                React.createElement("div", { className: style('name') }, name),
                React.createElement("div", { className: style('price') }, activeShade.price)),
            shades.map((shade) => (React.createElement("div", { key: shade.code, className: style('quickbuy', {
                    'is-visible': shade.code === activeShade.code,
                }) },
                React.createElement(QuickBuy, { code: shade.code })))))));
};
